import {
  FNOLOther,
  FNOLOtherLocationAndTime,
  FNOLOtherAdditionalInformation,
  FNOLTimeline,
  FNOLOtherLegalDate,
  FNOLOtherLegalAmount,
  FNOLOtherFireCause,
} from '../../../../../../pages/FNOL'

import { FSMTransitionsFNOLVehicleSE } from '../constants'

const {
  FNOL_OTHER_FLOW,
  FNOL_OTHER_FIRE_CAUSE,
  FNOL_OTHER_DAMAGE_LOCATION_AND_TIME,
  FNOL_OTHER_TIMELINE,
  FNOL_OTHER_LEGAL_DATE,
  FNOL_OTHER_LEGAL_AMOUNT,
  FNOL_OTHER_ADDITIONAL_INFORMATION,
} = FSMTransitionsFNOLVehicleSE

export default [
  {
    is: { [FNOL_OTHER_FLOW]: FNOL_OTHER_FLOW },
    page: FNOLOther,
  },
  {
    is: { [FNOL_OTHER_FLOW]: FNOL_OTHER_DAMAGE_LOCATION_AND_TIME },
    page: FNOLOtherLocationAndTime,
  },
  {
    is: { [FNOL_OTHER_FLOW]: FNOL_OTHER_ADDITIONAL_INFORMATION },
    page: FNOLOtherAdditionalInformation,
  },
  {
    is: { [FNOL_OTHER_FLOW]: FNOL_OTHER_TIMELINE },
    page: FNOLTimeline,
  },
  {
    is: { [FNOL_OTHER_FLOW]: FNOL_OTHER_LEGAL_DATE },
    page: FNOLOtherLegalDate,
  },
  {
    is: { [FNOL_OTHER_FLOW]: FNOL_OTHER_LEGAL_AMOUNT },
    page: FNOLOtherLegalAmount,
  },
  {
    is: { [FNOL_OTHER_FLOW]: FNOL_OTHER_FIRE_CAUSE },
    page: FNOLOtherFireCause,
  },
]
